import type {ReactElement} from 'react';
import {useRef} from 'react';
import React from 'react';
import styles from './design-seek-item-background-container.module.scss';
import {useInViewport} from 'ahooks';
import {useGetPagePreviewThumbUrl} from '@Hooks/poster-editor/useGetPagePreviewThumbUrl';

interface DesignSeekItemBackgroundContainerProps {
  pageId: string;
}

export function DesignSeekItemBackgroundContainer({pageId}: DesignSeekItemBackgroundContainerProps): ReactElement {
  const ref = useRef<HTMLDivElement | null>(null);
  const isInViewPort = useInViewport(ref);

  const pagePreviewThumbSrc = useGetPagePreviewThumbUrl(pageId, !!isInViewPort[0]);

  return (
    <div
      ref={ref}
      style={{
        backgroundImage: pagePreviewThumbSrc ? `url(${pagePreviewThumbSrc})` : undefined,
      }}
      className={`${styles.container} _full-width _full-height radius-8`}
    />
  );
}
